import moment from "moment";
import numeral from "numeral";

export const getStringLiteral = (...target) => {
  return target.filter(Boolean).join(" ");
};

export const getNumeral = (text, format = "0,0") => {
  return text ? numeral(text).format(format) : "-";
};

export const getMoment = (text, format = "DD/MM/YYYY") => {
  if (!text) return "-";
  const m = moment(text);
  return m.isValid() ? m.format(format) : text;
};

export const getCurrency = (amount, symbol = "฿", format = "0,0.00") => {
  if (amount == null || amount === "" || isNaN(amount)) return "-";
  return `${symbol}${numeral(amount).format(format)}`;
};

export const checkIfTextExceedsLines = (text, maxLines = 3, charsPerLine = 38) => {
  if (!text || text === "-") return false;
  const lines = String(text).split("\n");
  let totalLines = 0;
  for (const line of lines) {
    totalLines += Math.max(1, Math.ceil(line.length / charsPerLine));
  }
  return totalLines > maxLines;
};

export const displayTotal = (total, range) => {
  return `${numeral(range[0]).format()} - ${numeral(
    range[1]
  ).format()} of ${numeral(total).format()}`;
};